"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const faTimesCircle_1 = require("@fortawesome/pro-solid-svg-icons/faTimesCircle");

const react_fontawesome_1 = require("@fortawesome/react-fontawesome");

const Search_1 = __importDefault(require("@mui/icons-material/Search"));

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const PREFIX = 'SskySearchForMenu';
const classes = {
  clickable: `${PREFIX}-clickable`,
  clearIcon: `${PREFIX}-clearIcon`,
  root: `${PREFIX}-root`
};
const StyledInput = (0, material_1.styled)(material_1.Input)(() => ({
  [`& .${classes.clickable}`]: {
    cursor: "pointer"
  },
  [`& .${classes.clearIcon}`]: {
    color: "rgba(0, 0, 0, 0.54)",
    width: 24,
    height: 24
  },
  [`& .${classes.root}`]: {
    minHeight: 32,
    fontSize: 16,
    position: "sticky",
    top: 0,
    backgroundColor: "inherit",
    padding: 10,
    zIndex: 1
  }
}));

const SskySearchForMenu = props => {
  const renderEndAdornment = () => {
    return props.value ? react_1.default.createElement(material_1.InputAdornment, {
      position: "end"
    }, react_1.default.createElement("div", {
      className: classes.clickable,
      onClick: props.onClickCancel
    }, react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
      icon: faTimesCircle_1.faTimesCircle,
      className: classes.clearIcon
    }))) : react_1.default.createElement(material_1.InputAdornment, {
      position: "end"
    }, react_1.default.createElement(Search_1.default, {
      color: "action"
    }));
  };

  return react_1.default.createElement(material_1.Box, {
    sx: {
      padding: "6px 16px"
    }
  }, react_1.default.createElement(StyledInput, {
    autoFocus: true,
    classes: {
      root: classes.root
    },
    fullWidth: true,
    value: props.value,
    placeholder: props.placeholder,
    onChange: props.onChange,
    endAdornment: renderEndAdornment(),
    "data-testid": props.dataTestId
  }));
};

exports.default = react_1.default.memo(SskySearchForMenu);